// Service navigation chips (snippets/service-nav.liquid). On narrow screens the pills sit in one
// row that scrolls sideways; bring the pill of the current page into view inside that row.
// Only scrollLeft of the row changes, so the page itself never jumps.
for (const list of document.querySelectorAll('.service-nav--chips .service-nav__list')) {
  const current = list.querySelector('[aria-current="page"]');
  if (!current || list.scrollWidth <= list.clientWidth) continue;

  const item = current.closest('li') ?? current;
  const offset = item.getBoundingClientRect().left - list.getBoundingClientRect().left + list.scrollLeft;
  list.scrollLeft = Math.max(0, offset - (list.clientWidth - item.offsetWidth) / 2);
}
